import { render, staticRenderFns } from "./NovaEscala.vue?vue&type=template&id=b339642c&"
import script from "./NovaEscala.vue?vue&type=script&lang=js&"
export * from "./NovaEscala.vue?vue&type=script&lang=js&"
import style0 from "./NovaEscala.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports